import React, { useEffect, useState } from "react";
import { Button, message, Steps, theme } from "antd";
import svg51 from "../../../../../assets/svg/svg51.svg";
import Concept from "./concept/Concept";
import Header from "../Header";
import Feasibility from "./feasibility/Feasibility";
import Design from "./design/Design";
import License from "./license/License";
import Finance from "./finance/Finance";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchData } from "../../../../../features/fetch/fetchSlice";
import toast from "react-hot-toast";
import Approvals from "./approval/Approvals";

function OverviewStepList() {
  const [current, setcurrent] = useState(0);
  const urlSingle = "api/v2/main_projects/get";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, activeObjPlannedProject, dataProjSingle } = useSelector(
    (state) => ({
      loading: state.fetch.loading,
      activeObjPlannedProject: state.obj.activeObj["plannedProject"],
      dataProjSingle: state.fetch.data[urlSingle] || [],
    })
  );

  function handleNext() {
    setcurrent(current + 1);
  }

  function handleBack() {
    setcurrent(current - 1);
  }
  const steps = [
    {
      title: "Concept",
      content: <Concept handleNext={handleNext} handleBack={handleBack} />,
      icon: <img src={svg51} alty="svg51" />,
    },
    {
      title: "Feasibility",
      content: <Feasibility handleNext={handleNext} handleBack={handleBack} />,
      icon: <img src={svg51} alty="svg51" />,
    },
    {
      title: "Design",
      content: <Design handleNext={handleNext} handleBack={handleBack} />,
      icon: <img src={svg51} alty="svg51" />,
    },
    {
      title: "Licensing",
      content: <License handleNext={handleNext} handleBack={handleBack} />,
      icon: <img src={svg51} alty="svg51" />,
    },
    {
      title: "Approval",
      content: <Approvals handleNext={handleNext} handleBack={handleBack} />,
      icon: <img src={svg51} alty="svg51" />,
    }, 
    {
      title: "Finance",
      content: <Finance handleNext={handleNext} handleBack={handleBack} />,
      icon: <img src={svg51} alty="svg51" />,
    },
  ];

  const items = steps.map((item) => ({
    key: item.key,
    title: item.title,
    icon: item.icon,
  }));

  async function fetchSingleProjData() {
    await dispatch(
      fetchData({
        url: urlSingle,
        projectId: activeObjPlannedProject?.projectId,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    fetchSingleProjData();
  }, []);
 
  return (
    <>
      <div className="mt-[2.5rem]">
        <Steps
          className=""
          current={current}
          labelPlacement="vertical"
          items={items} 
          onChange={(value) => {
            if (
              (value === 3 && dataProjSingle?.[0]?.projectDesignApproval === 'No') || (value === 4 && dataProjSingle?.[0]?.projectDesignApproval === 'No')
            ) {
              toast.error(
                "Sorry! You cannot move to the next step before your designs are approved. Kindly take your documents for the projects for approval to the relevant offices.",
                {
                  position: "top-center",
                  autoClose: false,
                  style: {
                    background: "#475569",
                    color: "#fff",
                    width: "100%",
                    maxWidth: "100%",
                    borderRadius: "0px",
                    marginLeft: "15%",
                    marginRight: "1%",
                  },
                }
              );
              return;
            }
            setcurrent(value);
          }}
        />
      </div>
      <div className="mt-[2.12rem]">{steps[current].content}</div>
    </>
  );
}

export default OverviewStepList;
